import axios from 'axios';
import { getToken } from './auth';
import { v4 as uuidv4 } from 'uuid';

const useApi = () => {
  const token = getToken();
  let baseUrl = `https://${window.location.host}/api`;

  const options = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : 'Basic'
    }
  };

  return {
    baseUrl,
    options,

    download: (path: string) => {
      return baseUrl + path + '?access_token=' + token;
    },

    get: async (path: string, format?: 'json' | 'body') => {
      const response = await fetch(`${baseUrl}${path}`, options);

      if (!format || format === 'json') {
        return await response.json();
      } else {
        return await response.text();
      }
    },

    getPDF: async (path: string, headers?: any) => {
      const response = await axios(`${baseUrl}${path}` + '?access_token=' + token, { ...headers || {}, 'x-request-id': uuidv4() });
      return response.data;
    },

    post: async (path: string, data: any) => {
      const response: any = await axios(`${baseUrl}${path}`, {
        method: 'POST',
        data,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token ? `Bearer ${token}` : 'Basic'
        }
      });

      return response.data;
    },

    postConvertHeic: async (data: any) => {
      const response = await axios.post(`${baseUrl}/photos/convert/heic/jpg`, data, {
        responseType: 'blob',
        headers: {
          'authorization': `Bearer ${token}`
        }
      });
      return response.data;
    },

    postJpgBlob: async (data: any) => {
      const response = await axios.post(`${baseUrl}/photos/convert/uri/jpg`, data, {
        responseType: 'blob',
        headers: {
          'authorization': `Bearer ${token}`
        }
      });
      return response.data;
    },

    put: async (path: string, body: any, baseUrl?: string) => {
      const newOptions = JSON.parse(JSON.stringify(options));
      newOptions.method = 'put';
      newOptions.body = JSON.stringify(body);
      const response = await fetch(`${typeof (baseUrl) === 'undefined' ? baseUrl : baseUrl}${path}`, newOptions);
      return await response.json();
    },

    getRaw: async (path: string) => {
      const response = await fetch(`${baseUrl}${path}`, options);
      return response;
    },

    postToSelf: async (path: string, body: any) => {
      const response = await axios.post(path, body);

      if (response.status === 200 || response.status === 201) {
        try {
          return response.data
        } catch {
          return {
            code: 500,
            success: false,
            message: 'Error occured processing this request'
          }
        }
      } else {
        return {
          code: 500,
          success: false,
          message: 'Error occured processing this request'
        }
      }
    }
  }
}

export default useApi;
